import { render, staticRenderFns } from "./Province.vue?vue&type=template&id=61edf08c&"
import script from "./Province.vue?vue&type=script&lang=js&"
export * from "./Province.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports